export const SYSTEM_LANGUAGES = "SYSTEM_LANGUAGES";
export const CURRENT_LANGUAGE = "CURRENT_LANGUAGE";
